'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _epochToDate = require('./epochToDate');

var _epochToDate2 = _interopRequireDefault(_epochToDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var epoch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return (0, _epochToDate2.default)(epoch).toISOString().slice(0, 10);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/epochToUTCDateString.js
// module id = 60
// module chunks = 0